import * as angular from 'angular';
import {ShopActivity} from "../../models/activity/shopActivity";
import {SignalRHub} from "../../services/hubs/signalr-hub";
import {HubService} from "../../services/hubs/hub.service";

export interface LineSheetHub extends SignalRHub {
  joinGroup(shopId): Promise<any>;
  leaveGroup(shopId): Promise<any>;
}

export interface LineSheetHubService {
  createLineSheetHubForReact(getActivity: () =>  ShopActivity,
                             setState: (activity: ShopActivity) => void,
                             postConnect: () => void,
                             shopId: string): LineSheetHub;
}

export default angular.module('aps.hubs.lineSheet', ['aps.services.hubs'])
  .service('lineSheetHub', lineSheetHub)
  .name;

function lineSheetHub(hubService: HubService): LineSheetHubService {
  function createLineSheetHubForReact(
    getActivity: () => ShopActivity,
    setState: (activity: ShopActivity) => void,
    postConnect: () => void,
    shopId: string
  ): LineSheetHub {
    return hubService.createHub<LineSheetHub>('lineSheet', {
      listeners: {
        defectAdded: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.addDefectFromEvent(event);
          setState(activity);
        },
        defectDeleted: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.deleteDefectFromEvent(event);
          setState(activity);
        },
        defectCommentAdded: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.addDefectCommentFromEvent(event);
          setState(activity);
        },
        toolChangeAdded: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.addToolChangeFromEvent(event);
          setState(activity);
        },
        toolChangeEdited: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.editToolChangeFromEvent(event);
          setState(activity);
        },
        toolChangeDeleted: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.deleteToolChangeFromEvent(event);
          setState(activity);
        },
        toolChangeCommentAdded: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.addToolChangeCommentFromEvent(event);
          setState(activity);
        },
        toolChangeDefectDeleted: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.deleteToolChangeDefectFromEvent(event);
          setState(activity);
        },
        downtimeAdded: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.addDowntimeFromEvent(event);
          setState(activity);
        },
        downtimeDeleted: function(event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.deleteDowntimeFromEvent(event);
          setState(activity);
        },
        qualificationAdded: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.addQualificationFromEvent(event);
          setState(activity);
        },
        qualificationDeleted: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.deleteQualificationFromEvent(event);
          setState(activity);
        },
        defectMoldRejectUpdated: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.updateDefectMoldRejectFromEvent(event);
          setState(activity);
        },
        defectEquipFailureUpdated: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.updateDefectEquipFailureFromEvent(event);
          setState(activity);
        },        
        hourLocked: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.lockHourFromEvent(event);
          setState(activity);
        },
        hourUnlocked: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.unlockHourFromEvent(event);
          setState(activity);
        },
        downtimeDurationAdded: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.addDowntimeDurationFromEvent(event);
          setState(activity);
        },
        downtimeCommentAdded: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.addDowntimeCommentFromEvent(event);
          setState(activity);
        },
        checkListActivity: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.checkListActivityFromEvent(event);
          setState(activity);
        },
        defectHeldPalletsAdded: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.addDefectHeldPalletsFromEvent(event);
          setState(activity);
        },
        defectHeldPalletsDeleted: function (event) {
          var activity = getActivity();
          if (event.shopId !== activity.id) {
            return;
          }
          activity.deleteDefectHeldPalletsFromEvent(event);
          setState(activity);
        }
      },
      methods: ['leaveGroup', 'joinGroup'],
      postConnect: (hub: LineSheetHub) => {
        hub.invokeWithRetry(() => hub.joinGroup(shopId));

        if (postConnect) {
          postConnect();
        }
      }
    });
  }

  return {
    createLineSheetHubForReact: createLineSheetHubForReact
  };
}


// WEBPACK FOOTER //
// ./src/app/controllers/linesheet/lineSheet.hub.ts